import React, { useEffect, useState } from 'react';
import Rating from '@mui/material/Rating';
import Box from '@mui/material/Box';
import { BsPlayCircleFill } from 'react-icons/bs';
import { BiSolidFilePdf } from 'react-icons/bi';
import { useNavigate } from 'react-router-dom';


const FavoriteCard = ({ task }) => {

    const navigate = useNavigate();
    const [stars, setStars] = useState(0);

    useEffect(() => {
        setStars(task.starts);
    }, [])

    if (!task.is_favorite_user_task) {
        return;
    }

    const goToDetailCourse = () => {
        navigate(`/cursos${task.url_front}${task.id}`);
    };

    return (
        <div
            className="cursor-pointer gradient-internal-card pt-4 relative rounded-t-2xl shadow-lg flex flex-col items-center justify-end"
            style={{
                backgroundImage: "url('/images/background/Background-slides.png')",
                backgroundSize: "cover",
                backgroundPosition: "center"
            }}
            onClick={()=>{
                goToDetailCourse();
            }}
        >
            <div className="absolute top-[-20px] z-10">
                {task.type === 'video' ? (
                    <BsPlayCircleFill
                        className="rounded-full"
                        style={{
                            fontSize: '50px',
                            fill: 'white',
                            background: task.is_active ? '#4D2484' : '#9ca3af',
                            boxShadow: 'rgba(0, 0, 0, 1) 0px 0px 8px'
                        }}
                    />
                ) : (
                    <BiSolidFilePdf
                        style={{ fontSize: '50px', fill: '#FFFFFF' }}
                    />
                )}
            </div>
            <div className="flex flex-col items-center text-center justify-start w-full relative z-10">
                <div className="mt-4 mb-0 h-20 mx-2">
                    <h5 className="text-white text-center text-xs ApisBold">
                        {task.title}
                    </h5>
                </div>
                <div className="bg-white w-full py-1">
                    <Box className="flex flex-col lg:flex-row items-center justify-center" sx={{ '& > legend': { mt: 2 } }}>
                        <p className="m-0 p-0 ApisBold text-[12px] mx-2">Calificación:</p>
                        <Rating
                            onChange={(event, newValue) => {
                                setStars(newValue);
                            }}
                            name="simple-controlled"
                            value={stars}
                            readOnly
                        />
                    </Box>
                </div>
            </div>
        </div>
    );
};

export default FavoriteCard;
